exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".qrCode[data-v-06145439],\n.operate[data-v-06145439] {\n  color: #1890ff;\n  font-size: 14px;\n  cursor: pointer;\n}\n", ""]);

// exports
